const koQualityOverrides = {
  ko: {
    'Bullying, threats, hate, harassment, humiliation, blackmail, coercion, or intimidation.':'괴롭힘, 위협, 혐오, 지속적인 괴롭힘, 굴욕, 협박, 강요 또는 위압.',
    'RONI safety signals used to detect unsafe wording, bullying, harassment, grooming indicators, external-contact attempts, private information sharing, and other harmful patterns.':'위험한 표현, 괴롭힘, 지속적인 괴롭힘, 그루밍 징후, 외부 접촉 시도, 개인정보 공유 및 기타 유해 패턴을 탐지하는 RONI 안전 신호.',
    'To detect, prevent, investigate, and respond to bullying, harassment, grooming, exploitation, impersonation, evasion, unsafe external-contact attempts, and other harmful behavior.':'괴롭힘, 지속적인 괴롭힘, 그루밍, 착취, 사칭, 제한 회피, 위험한 외부 접촉 시도 및 기타 유해 행동을 탐지·예방·조사·대응하기 위해.'
  }
};

export default koQualityOverrides;
